import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`
export const ChangeManagementIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5008 13.5H9.20078V8.6H7.30078L9.90078 6L12.5008 8.5H10.5008V13.5Z" />
      <path d="M13.5 10.5H14.8V15.4H16.7L14.1 18L11.5 15.5H13.5V10.5Z" />
    </Svg>
  )
}
